const options = {
  5: "bg-emerald-200/5",
  10: "bg-emerald-200/10",
  25: "bg-emerald-200/25",
  50: "bg-emerald-200/50",
  75: "bg-emerald-200/75",
  90: "bg-emerald-200/90",
  100: "bg-emerald-200",
};

const from = {
  5: "from-emerald-200/5",
  10: "from-emerald-200/10",
  25: "from-emerald-200/25",
  50: "from-emerald-200/50",
  75: "from-emerald-200/75",
  90: "from-emerald-200/90",
  100: "from-emerald-200",
};

export default function getBackgroundEmerald200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
